import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  viewChild
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { BaseFormPageComponent } from "src/app/pages/shared/base/components/base-form-page.component";

@Component({
    selector: "app-sms-body-header",
    templateUrl: "./sms-body-header.component.html",
    styleUrls: ["./sms-body-header.component.scss"],
    standalone: false
})
export class SmsBodyHeaderComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  fields = "pages.customerDomains.form.fields.";
  readonly organSmsHeaderInput = viewChild<ElementRef>("organSmsHeader");
  readonly smsHeaderInput = viewChild<ElementRef>("smsHeader");
  smsHeader: string;
  organizationSmsHeader: string;
  smsBody: string;
  smsBodyWithHeaders: string;
  isOrganSmsHeaderAtFirst: boolean = false;
  //#endregion

  constructor(
    private renderer: Renderer2,

    private dialogRef: MatDialogRef<SmsBodyHeaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.smsBody = data?.smsBody;
    this.organizationSmsHeader = data?.organizationSmsHeader;
    this.smsHeader = data?.smsHeader;
    this.isOrganSmsHeaderAtFirst = data?.isOrganSmsHeaderAtFirst || false;
  }

  ngOnInit() {
    this.initForm();
    const organSmsHeaderInput = this.organSmsHeaderInput();
    if (organSmsHeaderInput)
      this.renderer.setProperty(
        organSmsHeaderInput.nativeElement,
        "value",
        this.organizationSmsHeader
      );
    const smsHeaderInput = this.smsHeaderInput();
    if (smsHeaderInput)
      this.renderer.setProperty(
        smsHeaderInput.nativeElement,
        "value",
        this.smsHeader
      );
    this.handleSmsHeadersPosition();
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      smsHeader: new FormControl(this.smsHeader),
      organizationSmsHeader: new FormControl(this.organizationSmsHeader),
      smsBody: new FormControl(),
      isAddSmsHeader: new FormControl(),
      smsHeaderPosition: new FormControl(),
      isOrganSmsHeaderAtFirst: new FormControl(),
      isSmsHeaderAtFirst: new FormControl(),
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close({
      organizationSmsHeader: this.organizationSmsHeader,
      smsHeader: this.smsHeader,
      isOrganSmsHeaderAtFirst: this.isOrganSmsHeaderAtFirst,
    });
    this.unSubs();
  }

  //#region onChange

  onChangeOrganSmsHeader(value: string) {
    const organSmsHeaderInput = this.organSmsHeaderInput();
    if (organSmsHeaderInput)
      this.renderer.setProperty(
        organSmsHeaderInput.nativeElement,
        "value",
        value
      );
    this.organizationSmsHeader = value;
    this.handleSmsHeadersPosition();
  }

  onChangeSmsHeader(value: string) {
    const smsHeaderInput = this.smsHeaderInput();
    if (smsHeaderInput)
      this.renderer.setProperty(
        smsHeaderInput.nativeElement,
        "value",
        this.smsHeader
      );
    this.smsHeader = value;
    this.handleSmsHeadersPosition();
  }

  onChangeSmsHeaderPosition(event?) {
    this.isOrganSmsHeaderAtFirst = event?.value || false;
    this.handleSmsHeadersPosition();
  }

  //#endregion

  handleSmsHeadersPosition() {
    this.smsBodyWithHeaders = "";

    if (this.isOrganSmsHeaderAtFirst)
      this.smsBodyWithHeaders =
        `${
          this.organizationSmsHeader ? this.organizationSmsHeader + "\n" : ""
        }` +
        `${this.smsHeader ? this.smsHeader + "\n" : ""}` +
        (this.smsBody || "");
    else
      this.smsBodyWithHeaders =
        `${this.smsHeader ? this.smsHeader + "\n" : ""}` +
        `${
          this.organizationSmsHeader ? this.organizationSmsHeader + "\n" : ""
        }` +
        (this.smsBody || "");
  }
}
